<div class="row p-1">
    <div class="col-12" *ngIf="loading">
        <div class="d-flex align-items-center">
            <span class="spinner-grow text-warning" role="status" aria-hidden="true"></span>
            <span class="ml-2">Please wait while loading ...</span>
        </div>
    </div>
    <div class="col-12" *ngIf="!loading && (!parameters || !parameters.templates)">
        <div class="alert alert-warning">
            <i class="mdi mdi-information-variant mr-1"></i> Nothing to show....!!!
        </div>
    </div>
    <div class="col-12" *ngIf="!loading && parameters && parameters.templates.length > 0">
        <div class="row">
            <div class="col-12">
                <div class="d-flex justify-content-between bg-pattern">
                    <div>
                        <div class="media mt-0 mb-0">
                            <div class="media-body mt-0 mb-0">
                                <h5 class="mb-0 text-capitalize">{{parameters.testName}}</h5>
                                <p class="font-12 mb-0 text-capitalize">{{parameters.testCode}}</p>
                                <small class="mb-0 text-capitalize">{{parameters.departmentName}}</small>
                            </div>
                        </div>
                    </div>
                    <div>
                        <button class="btn btn-outline-danger btn-sm" (click)="onClosePopup()">
                            <i class="mdi mdi-close mr-1"></i> Close
                        </button>
                    </div>
                </div>
                <hr class="mb-0" />
            </div>
            <div class="col-12" *ngFor="let template of parameters.templates;index as t;">
                <div class="card mb-1 shadow-none border bg-pattern">
                    <div>
                        <div class="row align-items-center">
                            <div class="col-auto">
                                <div class="avatar-sm">
                                    <span class="avatar-title badge-soft-primary text-primary rounded">
                                        <i class="mdi mdi-link-plus mdi-18px"></i>
                                    </span>
                                </div>
                            </div>
                            <div class="col ps-0">
                                <a href="javascript:void(0);" class="font-14 fw-bold">{{template.templateName}}</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" style="max-height:480px; overflow:auto;">
                    <div class="col-12" *ngIf="template.parameters && template.parameters.length > 0" style="max-height:600px; overflow:auto;">
                        <div class="headingStyle">
                            <div class="trapezium font-weight-semibold text-white">
                                <span class="p-1"><i class="mdi mdi-chart-gantt me-1"></i> <span>Direct Parameters</span></span>
                            </div>
                        </div>
                        <div class="card p-2">
                            <div class="row" *ngFor="let parameter of template.parameters;index as p;">
                                <div class="" [ngClass]="{'col-12' : parameter.referenceOutput === 'text' ,'col-8' : parameter.referenceOutput === 'numeric'}">
                                    <div class="form-group">
                                        <label class="mb-0"> {{parameter.parameterName}} <code>*</code></label>
                                        <input *ngIf="parameter.referenceOutput === 'numeric'" class="form-control" placeholder="Enter {{parameter.displayName}}" allowNumeric [(ngModel)]="parameter.observedValue" [ngStyle]="{'color': parameter.isBold ? 'red':'black'}" (input)="changeTextColor(parameter)" />
                                        <textarea rows="2" *ngIf="parameter.referenceOutput === 'text'" class="form-control" placeholder="Enter {{parameter.displayName}}" [(ngModel)]="parameter.observedValue"></textarea>
                                    </div>
                                </div>
                                <div class="col-4" *ngIf="parameter.referenceOutput === 'numeric'">
                                    <div class="form-group">
                                        <label class="mb-0"> Range<code>*</code></label>
                                        <div class="p-0 mb-0">
                                            <h5 class="mt-0 mb-0" *ngIf="parameter.labParameterDetailId">
                                                {{parameter.selected.minValue}}-{{parameter.selected.maxValue}}&nbsp;{{parameter.selected.unitName}} &nbsp;
                                                <i class="fe-edit" style="cursor: pointer;" (click)="onOpenForParameterSelection(templateReferenceRange,parameter)"></i>
                                            </h5>
                                            <div *ngIf="!parameter.labParameterDetailId">
                                                <button type="button" class="btn btn-sm waves-effect waves-light"
                                                        (click)="onOpenForParameterSelection(templateReferenceRange,parameter)">
                                                    Choose
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12" *ngFor="let component of template.components;index as c;">
                        <div class="headingStyle">
                            <div class="trapezium font-weight-semibold text-white">
                                <span class="p-1"><i class="mdi mdi-chart-gantt me-1"></i> <span [textContent]="component.componentName"></span></span>
                            </div>
                        </div>
                        <div class="card p-2">
                            <div class="row" *ngFor="let parameter of component.parameters;index as p;">
                                <div class="" [ngClass]="{'col-12' : parameter.referenceOutput === 'text' ,'col-8' : parameter.referenceOutput === 'numeric'}">
                                    <div class="form-group">
                                        <label class="mb-0"> {{parameter.parameterName}} <code>*</code></label>
                                        <input *ngIf="parameter.referenceOutput === 'numeric'" class="form-control" placeholder="Enter {{parameter.displayName}}" allowNumeric [(ngModel)]="parameter.observedValue" [ngStyle]="{'color': parameter.isBold ? 'red':'black'}" (input)="changeTextColor(parameter)" />
                                        <textarea rows="2" *ngIf="parameter.referenceOutput === 'text'" class="form-control" placeholder="Enter {{parameter.displayName}}" [(ngModel)]="parameter.observedValue"></textarea>
                                    </div>
                                </div>
                                <div class="col-4" *ngIf="parameter.referenceOutput === 'numeric'">
                                    <div class="form-group">
                                        <label class="mb-0"> Range<code>*</code></label>
                                        <div class="p-0 mb-0">
                                            <h5 class="mt-0 mb-0" *ngIf="parameter.labParameterDetailId">
                                                {{parameter.selected.minValue}}-{{parameter.selected.maxValue}}&nbsp;{{parameter.selected.unitName}} &nbsp;
                                                <i class="fe-edit" style="cursor: pointer;" (click)="onOpenForParameterSelection(templateReferenceRange,parameter)"></i>
                                            </h5>
                                            <div *ngIf="!parameter.labParameterDetailId">
                                                <button type="button" class="btn btn-sm waves-effect waves-light"
                                                        (click)="onOpenForParameterSelection(templateReferenceRange,parameter)">
                                                    Choose
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12" style="margin-top: -20px !important;" *ngIf="template.isMethod || template.isInterpretation">
                        <div class="card-box">
                            <div class="row">
                                <div class="col-sm-12 col-md-12 col-lg-12" *ngIf="template.isMethod">
                                    <div class="form-group">
                                        <label class="mb-1 font-16 font-weight-bold">Method <code>*</code></label>
                                        <div>
                                            <ckeditor [editor]="notesEditor" [config]="config" placeholder="Enter method text" [(ngModel)]="template.methodText"></ckeditor>
                                        </div>

                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-12 col-lg-12" *ngIf="template.isInterpretation">
                                    <div class="form-group">
                                        <label class="mb-1 font-16 font-weight-bold">Interpretation/Result <code>*</code></label>
                                        <div>
                                            <ckeditor [editor]="notesEditor" [config]="config" placeholder="Enter interpretation text" [(ngModel)]="template.interpretationText"></ckeditor>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="d-flex justify-content-end">
                    <button class="btn btn-danger btn-sm ml-1" (click)="onClosePopup()">
                        <i class="mdi mdi-close mr-1"></i> Close
                    </button>
                    <button type="button" *ngIf="!verifying" [disabled]="submitting" (click)="onSubmit()" class="btn btn-sm btn-primary">
                        <span *ngIf="!submitting">
                            <i class="mdi mdi-check mr-1"></i><span *ngIf="verifyAndSubmit">Verify and Submit</span>
                            <span *ngIf="!verifyAndSubmit">Submit</span>
                        </span>
                        <span *ngIf="submitting">
                            <span class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
                            Please wait..
                        </span>
                    </button>
                    <button *ngIf="verifying" class="btn btn-sm btn-primary">
                        <span>
                            <span class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
                            Please wait..
                        </span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #templateReferenceRange>
    <div class="modal-header d-flex justify-content-between">
        <div>
            <h4 class="modal-title">Lab Parameters Group</h4>
        </div>
        <div>
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true" (click)="onCloseModal();">×</button>
        </div>
    </div>
    <div class="modal-body">
        <table class="table table-centered table-sm table-striped table-bordered mb-0 heading1" style="padding:0px !important">
            <thead class="table-user">
                <tr>
                    <th>S.No</th>
                    <th>RangeText</th>
                    <th>Gender</th>
                    <th>FromAge</th>
                    <th>ToAge</th>
                    <th>MinValue</th>
                    <th>MaxValue</th>
                    <th>Min Critical</th>
                    <th>Max Critical</th>
                    <th>Unit</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let group of selectedParameter.allParameterDetail;index as i;">
                    <td>#{{i+1}}</td>
                    <td>
                        <span [textContent]="group.rangeText"></span>
                    </td>
                    <td>
                        <span [textContent]="group.gender"></span>
                    </td>
                    <td>
                        <span [textContent]="group.fromAge"></span>&nbsp;<span [textContent]="group.fromAgeType"></span>
                    </td>
                    <td>
                        <span [textContent]="group.toAge"></span>&nbsp;<span [textContent]="group.toAgeType"></span>
                    </td>
                    <td>
                        <span [textContent]="group.minValue"></span>
                    </td>
                    <td>
                        <span [textContent]="group.maxValue"></span>
                    </td>
                    <td>
                        <span [textContent]="group.minCriticalValue || '--'"></span>
                    </td>
                    <td>
                        <span [textContent]="group.maxCriticalValue || '--'"></span>
                    </td>
                    <td>
                        <span [textContent]="group.unitName || '--'"></span>
                    </td>
                    <td>
                        <button type="button" class="btn btn-sm btn-outline-primary" (click)="onSelectParameter(group)"><i class="mdi mdi-check"></i></button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</ng-template>